import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Dashboard from "@/components/RefClick/Dashboard";
import Stats from "@/pages/Stats";
import { TickProvider } from "@/components/RefClick/TickProvider";
import AuthProvider from "@/components/RefClick/AuthProvider";
import ErrorBoundary from "@/components/ErrorBoundary";
import { registerServiceWorker } from "@/lib/pwa";

/**
 * App shell — SPA with two routes:
 *   /           → Dashboard (main link list)
 *   /stats      → Stats page (30-day history + streaks + exports)
 *   anything else → Dashboard (SPA fallback for direct-URL loads)
 *
 * Providers (order matters):
 *   TickProvider    drives every "N seconds ago" label from one shared
 *                   1-second interval.
 *   AuthProvider    owns the PIN modal + lock state (currently the PIN
 *                   system is disabled via env, but the provider stays
 *                   installed so re-enabling is a one-line env flip).
 *   Toaster         Sonner mounted once at the root.
 */
export default function App() {
  // Kick off the service worker registration once, in the effect so
  // it runs after the app is hydrated and won't block first paint.
  useEffect(() => {
    registerServiceWorker();
  }, []);

  return (
    <div className="App">
      <ErrorBoundary>
        <TickProvider>
          <AuthProvider>
            <BrowserRouter>
              <Routes>
                <Route path="/stats" element={<Stats />} />
                <Route path="/" element={<Dashboard />} />
                <Route path="*" element={<Dashboard />} />
              </Routes>
            </BrowserRouter>
            <Toaster
              theme="dark"
              position="bottom-center"
              toastOptions={{
                style: {
                  background: "rgb(20 20 22 / 0.95)",
                  border: "1px solid rgb(255 255 255 / 0.08)",
                  color: "rgb(250 250 250)",
                  backdropFilter: "blur(16px)",
                },
              }}
            />
          </AuthProvider>
        </TickProvider>
      </ErrorBoundary>
    </div>
  );
}
